<template>
  <section class="cards__container">
    <div class="head-card">
      <div class="head-card__left">
        <p class="head-card__left__title">Produtos Ativos</p>
        <p v-if="!loading" class="head-card__left__info">
          {{ totalProdutosAtivos }}
        </p>
        <b-skeleton v-else width="60%"></b-skeleton>
      </div>
      <div class="head-card__right"><i class="fas fa-user-tie"></i></div>
    </div>
    <div class="head-card">
      <div class="head-card__left">
        <p class="head-card__left__title">Peso Produtos Ativos</p>
        <p v-if="!loading" class="head-card__left__info">
          {{ totalPesoProdutos }}
        </p>
        <b-skeleton v-else width="60%"></b-skeleton>
      </div>
      <div class="head-card__right"><i class="fas fa-exclamation"></i></div>
    </div>
  </section>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import MetasRepository from '@/shared/http/repositories/metas/metas.js'

export default {
  name: 'FilterKpi',
  mixins: [ActionsForm],
  props: ['gerenteId'],
  data () {
    return {
      loading: true,
      totalProdutosAtivos: 0,
      totalPesoProdutos: 0
    }
  },
  watch: {
    gerenteId: {
      handler (newVal, oldVal) {
        if (newVal) {
          this.loadKpi()
        }
      },
      immediate: true
    }
  },
  methods: {
    loadKpi () {
      loading.push()
      MetasRepository.GetKPIByUserId(this.gerenteId.value)
        .then((response) => {
          let content = response.data

          if (content) {
            this.totalPesoProdutos = content.totalPeso
            this.totalProdutosAtivos = content.totalProdutos
            this.loading = false
          }
        })
        .catch(this.onException)
        .finally(() => {
          loading.pop()
        })
    },
    clearData () {
      this.totalProdutosAtivos = 0
      this.totalPesoProdutos = 0
      this.loading = true
    }
  }
}
</script>

<style lang="scss" scoped>
.cards__container {
  display: flex;
  justify-content: flex-start;
  gap: 1.5rem;
  margin-top: 2rem;
  margin-bottom: 1.5rem;

  @media screen and (max-width: 768px) {
    overflow: scroll;
  }

  .head-card {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0.75rem 1rem;
    height: 5rem;
    width: 25%;

    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.12);
    border-radius: 4px;

    @media screen and (max-width: 768px) {
      min-width: 12rem;
    }

    &__left {
      &__title {
        font-size: 0.75rem;
        line-height: 100%;
        text-transform: uppercase;
        color: #8898aa;
        margin-bottom: 0.5rem;
      }

      &__info {
        font-weight: 600;
        font-size: 1rem;
        line-height: 100%;
        text-transform: uppercase;
        color: #4f5358;
      }

      .money::before {
        content: "R$ ";
      }
    }

    &:nth-child(1) .head-card__right {
      background: linear-gradient(90deg, #f53959 0%, #f55d39 100%);
    }

    &:nth-child(2) .head-card__right {
      background: linear-gradient(90deg, #fb6641 0%, #fbab40 100%);
    }

    &:nth-child(3) .head-card__right {
      background: linear-gradient(90deg, #2dce8b 0%, #2dceca 100%);
    }

    &:nth-child(4) .head-card__right {
      background: linear-gradient(180deg, #11c8ef 0%, #1275ef 100%);
    }

    &__right {
      width: 2rem;
      height: 2rem;
      aspect-ratio: 1;
      border-radius: 999px;

      display: flex;
      align-items: center;
      justify-content: center;

      i::before {
        font-size: 1rem;
        background: linear-gradient(
            180deg,
            #ffffff 0%,
            rgba(255, 255, 255, 0) 137.5%
        );
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros/metas-gerente/components/FilterKpi.vue